// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_LANDING_PAGE_HERO_TITLE = "Let's get you hired";
